<template>
  <div class="swiper_box">
    <swiper @slideChange="onSlideChange" :style="{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff'}" :spaceBetween="10" :navigation="true" :thumbs="{ swiper: thumbsSwiper }" class="mySwiper2">
      <template v-if="type=='img'">
          <template v-for="(item,ind) in list" :key="ind">
          <swiper-slide>
            <!-- :preview-src-list="list.map(img=>{return img.attach_value})" -->
            <el-image
              style="width:100%;height:100%"
              fit="contain"
              :src="item.attach_value"
              
              :initial-index="ind"
              z-index="99999"
              :append-to-body="true"
            >
            </el-image>
          </swiper-slide>
        </template>
      </template>
        <template v-else>
          <template v-for="(item,ind) in list" :key="ind">
            <swiper-slide>
              <video controlsList="nodownload" controls="controls" :src="item.attach_value"></video>
            </swiper-slide>
        </template>
      </template>
    </swiper>
    <swiper @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="8" :freeMode="true" :watchSlidesProgress="true" :navigation="true" class="mySwiper">
        <template v-if="type=='img'">
           <template v-for="(item,ind) in list" :key="ind">
            <swiper-slide>
              <img :src="item.attach_value" />
            </swiper-slide>
          </template>
        </template>
         <template v-else>
           <template v-for="(item,ind) in list" :key="ind">
              <swiper-slide>
                <video controlsList="nodownload" preload="meta" :src="item.attach_value"></video>
              </swiper-slide>
          </template>
        </template>
    </swiper>
  </div>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
// Import Swiper styles
import 'swiper/swiper.min.css'
import "swiper/modules/free-mode/free-mode.min.css"
import "swiper/modules/navigation/navigation.min.css"
import 'swiper/swiper.min.css';
import {
  ElImage
} from "element-plus";

// import Swiper core and required modules
import SwiperCore, {
  FreeMode,Navigation,Thumbs
} from 'swiper';
import { ref } from "vue";
// install Swiper modules
SwiperCore.use([FreeMode,Navigation,Thumbs]);
export default {
  components: {
    Swiper,
    SwiperSlide,
    ElImage
  },
  props:["list","type"],
  setup() {
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    const onSlideChange = () => {
      document.querySelectorAll("video").forEach(item=>{
        item.pause();
      })
    };
    return {
      Thumbs,
      thumbsSwiper,
      setThumbsSwiper,
      onSlideChange,
    };
  }
}
</script>

<style scoped lang="less">
.swiper_box{
  width: 100vw;
  height: 100vh;

  .mySwiper{
    max-width: 80vw;
    height: 100px;
    margin: 0 auto;
    .swiper-slide{
      height: 100px;
      border: solid 4px transparent;
      background: transparent;
      overflow:hidden;
      background: #666;
      &.swiper-slide-thumb-active {
        border: solid 4px #fff;
        border-radius: 5px;
      }
      video,img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .mySwiper2{
    width:100%;
    height: calc(100vh - 100px);
    .swiper-slide{
      width: 100%;
      height:100%;
      display: flex;
      justify-content: center;
      align-items: center;
      video,img{
        max-width: 100%;
        height: 100%;
        object-fit: contain;
        flex-shrink: 0;
        justify-self: center;
      }
      // .my_swiper_dialog_close2{
      //   width: 40px;
      //   height: 40px;
      //   margin: 0 40px;
      //   background: transparent;
      // }
      // .my_swiper_dialog_close {
      //   width: 40px;
      //   height: 40px;
      //   background: #fff;
      //   border-radius: 50%;
      //   position: sticky;
      //   top: 40px;
      //   left: calc(100vw - 80px);
      //   z-index: 2;
      //   align-self: flex-start;
      //   margin: 0 40px;
      //   flex-shrink: 0;
      // }
    }
  }

}





/* .swiper-slide {
  text-align: center;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  width: 100%;
  height: 85%;
}

.mySwiper {
  width:80%;
  height: 13%;
  box-sizing: border-box;
  margin-top: 1%;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  max-height: 100px;
  border: solid 4px transparent;
  background: transparent;
  overflow:hidden;
}

.mySwiper .swiper-slide-thumb-active {
  border: solid 4px #fff;
  border-radius: 5px;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.swiper-slide video {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: 70%;
  object-fit: contain;
}

.swiper_box{
  width: 100vw;
  height: 100vh;
} */

</style>